import { styled } from '../../../theme/styled';

export const TabHeader = styled('div', {
  name: 'Tabs',
  slot: 'Header',
})(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  borderBottom: `1px solid ${theme.palette['gray middle']}`,
  flexWrap: 'wrap',
}));
